export const RESET_ACTIVITY_SUMMARY = 'RESET_ACTIVITY_SUMMARY'
export const ACTIVITY_SUMMARY_LOADING = 'ACTIVITY_SUMMARY_LOADING'
export const ACTIVITY_SUMMARY_CONTACTS = 'GET_SUMMARY_CONTACTS'
export const CLEAR_ACTIVITY_SUMMARY_CONTACTS = 'CLEAR_ACTIVITY_SUMMARY_CONTACTS'

export const GET_PAS_DUE_TASKS_COUNT = 'GET_PAS_DUE_TASKS_COUNT'

export const GET_SUMMARY_CALLS = 'GET_SUMMARY_CALLS'
export const GET_SUMMARY_CALL_TIME = 'GET_SUMMARY_CALL_TIME'
export const GET_SUMMARY_INCOMING_CALLS = 'GET_SUMMARY_INCOMING_CALLS'
export const GET_SUMMARY_INCOMING_CALL_TIME = 'GET_SUMMARY_INCOMING_CALL_TIME'
export const GET_SUMMARY_EMAILS = 'GET_SUMMARY_EMAILS'
export const GET_SUMMARY_DEMOS = 'GET_SUMMARY_DEMOS'
export const GET_SUMMARY_MEETINGS = 'GET_SUMMARY_MEETINGS'
export const GET_SUMMARY_PROSPECTS = 'GET_SUMMARY_PROSPECTS'
export const GET_SUMMARY_ACCOUNTS = 'GET_SUMMARY_ACCOUNTS'
export const GET_SUMMARY_REFERRALS = 'GET_SUMMARY_REFERRALS'
export const GET_SUMMARY_GIVE_UPS = 'GET_SUMMARY_GIVE_UPS'
export const GET_SUMMARY_LONG_CALLS = 'GET_SUMMARY_LONG_CALLS'
